function getFetchConfig(body, method = 'POST') {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    config.method = method;
    config.body = body;

    return config;
}

function handleErrorMessage(errorMessage = false, hideErrors = false) {
    if (this.hideErrors) return;

    let errorMessageWrapper = this.querySelector('.alert.danger');
    if (!errorMessageWrapper) return;

    let errorMessageContent = errorMessageWrapper.querySelector('.alert__content');

    errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    const _createErrorMessageElement = (tag, err) => {
        const el = document.createElement(tag);
        el.textContent = err;
        return el;
    };

    if (errorMessage) {
        if (Array.isArray(errorMessage)) {
            const list = document.createElement('ul');
            list.classList.add('list-disc', 'list-inside');

            for (let err of errorMessage) {
                list.append(_createErrorMessageElement('li', err));
            }

            errorMessageContent.append(list);
        } else {
            errorMessageContent.append(_createErrorMessageElement('p', errorMessage));
        }
    } else {
        errorMessageContent.replaceChildren();
    }
}

class DeactivateButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('click', (e) => {
            window.Swal.fire({
                title: 'Sind Sie sicher?',
                text: `Diese Aktion kann nicht rückgängig gemacht werden. Alle Bestellungen und Entwürfe werden unwiederbringlich gelöscht.`,
                showCancelButton: true,
                cancelButtonText: 'Abbrechen',
                confirmButtonText: 'Konto löschen',
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        const response = await fetch(`/apps/api/account`, { method: 'DELETE' });
                        if (!response.ok) {
                            throw new Error(response.statusText);
                        }

                        return true;
                    } catch (error) {
                        console.log(error);
                        window.Swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !window.Swal.isLoading(),
                customClass: {
                    popup: 'flex flex-col gap-4 !rounded-2xl justify-center items-center',
                    title: '!text-xl !font-light',
                    htmlContainer: '!text-base !font-light',
                    input: '!w-1/2 !my-0 !mx-auto !text-base',
                    actions: 'flex-row-reverse !my-0',
                    loader: '!border-t-access-foreground !border-b-access-foreground',
                    inputLabel: '',
                    validationMessage: '',
                    confirmButton: 'btn danger',
                    denyButton: '',
                    cancelButton: 'btn',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        });
    }
}

customElements.define('deactivate-account', DeactivateButton);

class ResellerApplicationForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.successContainer = this.querySelector('[data-alert="success"]');
        this.submitButton = this.querySelector('[type="submit"]');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        handleErrorMessage.bind(this)();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const config = getFetchConfig(formData);

        // send request via
        try {
            const response = await fetch(`/apps/api/reseller/apply`, config);
            const resBody = await response.json();
            console.dir(resBody);

            if (response.status === 401) {
                window.location.href = '/';
                return;
            }

            if (response.status !== 201) {
                handleErrorMessage.bind(this)(resBody.message);
                return;
            }

            this.form.reset();
            this.successContainer.removeAttribute('hidden');
        } catch (e) {
            handleErrorMessage.bind(this)('Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
        } finally {
            console.dir('finally');
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }
}

customElements.define('reseller-form', ResellerApplicationForm);

class RegisterForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.successContainer = this.querySelector('div.success-container');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        handleErrorMessage.bind(this)();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const config = getFetchConfig(formData);

        try {
            const response = await fetch(`/apps/api/account`, config);
            const resBody = await response.json();
            console.dir(resBody);

            if (response.status === 401) {
                window.location.href = '/';
                return;
            }

            if (response.status !== 201) {
                handleErrorMessage.bind(this)(resBody.message);
                if (typeof hcaptcha !== 'undefined') hcaptcha.reset();
                return;
            }

            this.successContainer.removeAttribute('hidden');
            this.form.setAttribute('hidden', true);
        } catch (e) {
            console.dir('hello');
            console.error(e);
        } finally {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }
}

customElements.define('register-form', RegisterForm);

class CustomerForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.successContainer = this.querySelector('div.success-container');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        handleErrorMessage.bind(this)();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const config = getFetchConfig(formData, 'PATCH');

        // send request via
        try {
            const response = await fetch(`/apps/api/account`, config);
            const resBody = await response.json();
            console.dir(resBody);

            if (response.status !== 200) {
                handleErrorMessage.bind(this)(resBody.message);
                return;
            }

            this.successContainer.removeAttribute('hidden');
        } catch (e) {
            console.dir('hello');
            console.error(e);
        } finally {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }
}

customElements.define('customer-form', CustomerForm);

class CustomerAddressForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.addressId = this.form.dataset.id;

        this.successContainer = this.querySelector('div.success-container');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.inputWrapper = this.form.querySelector('.input-wrapper');
        this.submitButton = this.querySelector('[type="submit"]');
        this.editButton = this.querySelector('button[data-action="edit"]');
        this.deleteButton = this.querySelector('button[data-action="delete"]');
        this.cancelButton = this.querySelector('button[data-action="cancel"]');
        this.setDefaultButton = this.querySelector('button[data-action="setDefault"]');
        this.addNewButton = this.querySelector('button[data-action="add"]');

        this.cancelButton.addEventListener('click', this.cancelEdit.bind(this));

        if (this.addNewButton) {
            this.addNewButton.addEventListener('click', this.enableForm.bind(this));
        }

        if (this.editButton) {
            this.editButton.addEventListener('click', this.enableForm.bind(this));
        }

        if (this.setDefaultButton) {
            this.setDefaultButton.addEventListener('click', () => {
                this.form.removeAttribute('disabled');
                this.form.querySelectorAll('input, select').forEach((e) => e.removeAttribute('disabled'));

                this.onSubmitHandler
                    .bind(this)(null, true)
                    .then(() => {
                        window.location.reload();
                    });
            });
        }

        if (this.deleteButton) {
            this.deleteButton.addEventListener('click', () => {
                if (confirm('Soll diese Adresse wirklich entfernt werden?')) {
                    this.DeleteHandler.bind(this)().then(() => {
                        window.location.reload();
                    });
                }
            });
        }
    }

    cancelEdit(reset = true) {
        if (reset) {
            this.form.reset();
        }

        // switch buttons
        this.cancelButton.setAttribute('hidden', 'true');
        this.submitButton.setAttribute('hidden', 'true');

        if (this.inputWrapper) {
            this.addNewButton.removeAttribute('hidden');
            this.inputWrapper.setAttribute('hidden', 'true');
        } else {
            this.editButton.removeAttribute('hidden');

            if (this.deleteButton) {
                this.deleteButton.removeAttribute('hidden');
            }
        }

        this.form.setAttribute('disabled', 'true');
        this.form.querySelectorAll('input, select').forEach((e) => e.setAttribute('disabled', 'true'));
    }

    async enableForm() {
        // switch buttons
        this.cancelButton.removeAttribute('hidden');
        this.submitButton.removeAttribute('hidden');

        if (this.inputWrapper) {
            this.addNewButton.setAttribute('hidden', 'true');
            this.inputWrapper.removeAttribute('hidden');
        } else {
            this.editButton.setAttribute('hidden', 'true');

            if (this.deleteButton) {
                this.deleteButton.setAttribute('hidden', 'true');
            }
        }

        this.form.removeAttribute('disabled');
        this.form.querySelectorAll('input, select').forEach((e) => e.removeAttribute('disabled'));
    }

    async DeleteHandler() {
        const formData = new FormData(this.form);
        const config = getFetchConfig(formData, 'DELETE');

        if (!this.addressId) {
            return;
        }

        try {
            const response = await fetch(`/apps/api/account/address/${this.addressId}`, config);
            const resBody = await response.json();
            console.dir(resBody);

            if (response.status === 401) {
                window.location.href = '/';
                return;
            }

            if (response.status !== 200) {
                handleErrorMessage.bind(this)(resBody.message);
                return;
            }

            this.successContainer.removeAttribute('hidden');
        } catch (e) {
            console.dir('hello');
            console.error(e);
        } finally {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }

    async onSubmitHandler(evt, setDefault = false) {
        if (evt) {
            evt.preventDefault();
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        handleErrorMessage.bind(this)();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        if (setDefault) {
            formData.append('setAsDefault', true);
        }

        const isUpdate = !!this.addressId;

        const config = getFetchConfig(formData, isUpdate ? 'PATCH' : 'POST');
        // send request via
        try {
            const url = isUpdate ? `/apps/api/account/address/${this.addressId}` : `/apps/api/account/address`;
            const response = await fetch(url, config);
            const resBody = await response.json();

            if (response.status === 401) {
                window.location.href = '/';
                return;
            }

            if ((isUpdate && response.status !== 200) || (!isUpdate && response.status !== 201)) {
                handleErrorMessage.bind(this)(resBody.message);
                return;
            }

            this.cancelEdit(false);
            this.successContainer.removeAttribute('hidden');

            setTimeout(() => {
                this.successContainer.setAttribute('hidden', 'true');
                window.location.reload();
            }, 1_500);
        } catch (e) {
            console.dir('hello');
            console.error(e);
        } finally {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            this.querySelector('.loading__spinner').classList.add('hidden');
        }
    }
}

customElements.define('customer-address-form', CustomerAddressForm);
